import React, { useState } from "react";
import { useSelector } from "react-redux";
import ReactVirtualizedTable from "../../../../components/table";
import ReusableButton from "../../../../components/button";
import ReusableDropdown from "../../../../components/drop-down";
import { YearOptions } from "../../../../../constants/tab-toolbar-constants";
import LoaderSpinner from "../../../../components/loading-spinner";
import TableDataLabels from "../../../../components/table-data-label";
import { ApiConfig } from "../../../../../configuartions/api-config";
/**
 * Balancesheet Component
 *
 * This component represents the Balance Sheet section of the ARS Artificial Intelligence Reporting System WebApp.
 * It renders the container with a heading for the balance sheet.
 *
 * @param {Object} props - The props object for the component.
 * @returns {JSX.Element}
 */
const Balancesheet = (props) => {
  const { tabDisplay } = useSelector((state) => state.console);
  const [selectedOption, setSelectedOption] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadedYear, setLoadedYear] = useState(null);
  const [rows, setRows] = useState(null);

  const handleSelect = (value) => {
    setSelectedOption(value);
    console.log("Selected Option:", value);
  };

  const onClickHandler = async () => {
    setLoadedYear(selectedOption);
    setLoading(true);
    setLoaded(false); // Reset loaded state when new load starts
    // setTimeout(() => {
    //   setLoading(false);
    //   setLoaded(true);
    // }, 5000); // Simulating loading time
    try {
      const headers = {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      };
      const response = await fetch(
        `${ApiConfig().api}/balance-sheet/report?year=${selectedOption}`,
        {
          method: "GET",
          headers: headers,
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();
      setRows(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
      setLoaded(true);
    }
  };

  return (
    <div className="balancesheet-container">
      <h2>
        {tabDisplay.toUpperCase()}:&nbsp;
        {loadedYear ? (
          loadedYear
        ) : (
          <span
            style={{
              color: "gray",
              fontStyle: "italic",
              fontSize: "0.9em",
              marginLeft: "1em",
            }}
          >
            Please select a year and load!
          </span>
        )}
      </h2>
      <div className="container-toolbar">
        <ReusableDropdown
          options={YearOptions}
          onSelect={handleSelect}
          disabledText={"select year..."}
        />
        <ReusableButton
          buttonText="Load"
          width="auto"
          height="30px"
          disabled={!selectedOption}
          onClick={onClickHandler}
        />
        <TableDataLabels />
      </div>
      <div className="balancesheet-content">
        {loading ? (
          <LoaderSpinner />
        ) : loaded ? (
          <ReactVirtualizedTable rows={rows} />
        ) : null}
      </div>
    </div>
  );
};

export default Balancesheet;
